import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput
 }
from 'admin-on-rest/lib/mui';

export const ZicuNoMakorList = (props) => (
    <List title="זיכויים ללא עסקת מקור" {...props}>
        <Datagrid>
        <TextField label="בית עסק" source="buisiness_id" />
        <TextField label="תנועה" source="tnuaa_type" />
            <TextField label="כרטיס אשראי" source="cc_id" />
             <TextField label="סכום" source="zikui_total_bruto" />
             
             
            
  
        </Datagrid>
    </List>
);




              



// WEBPACK FOOTER //
// ./src/components/RiskManagement/ZicuNoMakor/ZicuNoMakor.js